import { render, staticRenderFns } from "./DialogSendQuestNotification.vue?vue&type=template&id=6d636dbd&scoped=true&"
import script from "./DialogSendQuestNotification.vue?vue&type=script&lang=js&"
export * from "./DialogSendQuestNotification.vue?vue&type=script&lang=js&"
import style0 from "./DialogSendQuestNotification.vue?vue&type=style&index=0&id=6d636dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d636dbd",
  null
  
)

export default component.exports